<section id="team" tabindex="-1" class="date-tabs pt-400 section-padding30">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-9 col-sm-9 col-12">
                <div class="section-title text-center mb-100">
                    <h1>Le nostre sedi</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="team-area pb-150 mt-5">
        <div class="container">
            <div class="row">
                <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-team mb-30">
                        <div class="team-img">
                            <video #videoPlayer width="100%" height="auto" controls autoplay [muted]="true">
                                <source src="resources/video/palestra.mp4" type="video/mp4" />
                            </video>
                            <div class="team-caption" id="bgSede">
                                <span>FONTE LAURENTINA</span>
                                <h1><a href="#">Viale Leonida Tonelli 82-84-86, 00134, Roma</a></h1>
                                <div class="team-social">
                                    <ul>
                                        <li><a href="https://www.instagram.com/fullmuscle.laurentina/"><i
                                                    class="fab fa-instagram"></i></a></li>
                                        <li><a class="text-lowercase" href="mailto:{{mailFonte}}"><em
                                                    class="bi bi-envelope"></em></a>
                                        </li>
                                        <li><a href="tel:3201555850"><em class="bi bi-telephone"></em></a></li>
                                        <li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-team mb-30">
                        <div class="team-img">
                            <video #videoPlayer width="100%" height="auto" controls autoplay [muted]="true">
                                <source src="resources/video/trigoria.mp4" type="video/mp4" />
                            </video>
                            <div class="team-caption" id="bgSede">
                                <span>TRIGORIA</span>
                                <h1><a href="#">Via di Trigoria 57, 00128, Roma</a></h1>
                                <div class="team-social">
                                    <ul>
                                        <li><a href="https://www.instagram.com/fullmuscle.trigoria/"><i
                                                    class="fab fa-instagram"></i></a></li>
                                        <li><a href="tel:3513465069"><em class="bi bi-telephone"></em></a></li>
                                        <li><a class="text-lowercase" href="mailto:{{mailTrigoria}}"><em
                                                    class="bi bi-envelope"></em></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <h2 class="map-title">Fonte Laurentina</h2>
                    <div id="map" class="map-responsive">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.6068023283174!2d12.49112867538139!3d41.79368687069614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258b867272471f%3A0x125b1e87233b7902!2sV.le%20Leonida%20Tonelli%2C%2084%2C%2000134%20Roma%20RM!5e0!3m2!1sit!2sit!4v1750520488000!5m2!1sit!2sit"
                            allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <h2 class="map-title">Trigoria</h2>
                    <div id="map" class="map-responsive">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1761.9859192012366!2d12.477924192720069!3d41.769847486029775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258cf4936d9fd5%3A0x1a3edf9811880332!2sVia%20di%20Trigoria%2C%2057%2C%2000128%20Roma%20RM!5e0!3m2!1sit!2sit!4v1764856577904!5m2!1sit!2sit"
                            allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>